<template>
  <div
    class="animated fadeIn"
    v-bind:style="{ backgroundColor: territory.rotation_edit.RotationColor }"
  >
    <b-row style="height: 15px;">
      <b-col lg="12"> </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-form-group class="pl-3">
          <CoolSelect
            v-model="territoryToLoad"
            class="form-input dropdown-content"
            theme="bootstrap"
            tooltip="Territory"
            :items="territory.temp_territories"
            item-text="TerritoryName"
            item-value="TerritoryID"
            id="TerritoryID"
            @select="setTerritoryEdit"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text class="standardizedWidth"
                  >Territory Check</b-input-group-text
                >
              </b-input-group-prepend>
            </template>
            <!-- <template slot="item" slot-scope="{ item }">
                    <div class="item">
                      <img :src="item.thumbnail" class="logo" />
                      <span class="item-name">{{ item.CommonName }}</span>
                    </div>
            </template>-->
          </CoolSelect>
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group>
          <CoolSelect
            v-model="rotationToLoad"
            class="form-input dropdown-content"
            theme="bootstrap"
            tooltip="Cluster"
            :items="territory.rotations"
            item-text="RotationName"
            item-value="RotationID"
            id="RotationID"
            @select="setRotationEdit"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text>Cluster</b-input-group-text>
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group class="pr-3">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Radius</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="territory.territory_edit.DefaultRadius"
              placeholder="Radius"
              autocomplete="off"
              type="text"
              id="DefaultRadius"
              v-mask="'###'"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12"> </b-col>
    </b-row>

    <b-row>
      <b-col lg="12">
        <RotationMap />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import RotationMap from "@/components/maps/RotationMap.vue";
import { mapState } from "vuex";
import cTable from "@/views/base/Table.vue";
import { CoolSelect } from "vue-cool-select";

export default {
  components: {
    RotationMap,
    cTable,
    CoolSelect
  },
  computed: {
    ...mapState(["territory", "n_user"])
  },
  data: () => {
    return {
      territoryToLoad: -99,
      rotationToLoad: -99
    };
  },
  created() {},
  mounted() {
    if (this.$store.state.territory.territory_edit) {
      this.territoryToLoad = this.$store.state.territory.territory_edit.TerritoryID;
    }
    if (this.$store.state.territory.rotation_edit) {
      this.rotationToLoad = this.$store.state.territory.rotation_edit.RotationID;
    }
  },

  methods: {
    setTerritoryEdit() {
      this.$store.dispatch("territory/loadTerritoryEdit", this.territoryToLoad);
    },
    setRotationEdit() {
      this.$store.dispatch("territory/loadRotationEdit", this.rotationToLoad);
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped></style>
